import React, { useState } from "react";
import { Layout, Drawer, Grid } from "antd";
const { useBreakpoint } = Grid;
import ChatWindowSection from "./sections/ChatWindowSection";
import MetadataSection from "./sections/MetaDataSection";

const { Content } = Layout;

const PlaygroundComponent = ({
  responseData,
  setResponseData,
  spinning,
  setSpinning,
  drawerData,
  setDrawerData,
}) => {
  const screens = useBreakpoint();
  const isMobile = !screens.md;
  const [visible, setVisible] = useState(false);
  
  const onClose = () => {
    setVisible(false);
  };
  
  return (
    <Layout
      style={{
        height: "100%",
        minHeight: 0,
        overflow: "hidden",
        background: "#fff",
        display: "flex",
        flexDirection: "row",
        border: isMobile ? "none" : "1px solid #f0f0f0",
        borderRadius: "12px",
      }}
    >
      <ChatWindowSection
        setVisible={setVisible}
        responseData={responseData}
        setResponseData={setResponseData}
        spinning={spinning}
        setSpinning={setSpinning}
        setDrawerData={setDrawerData}
        isMobile={isMobile}
      />
      
      <Drawer
        visible={visible}
        onClose={onClose}
        title={<div>AI Actions</div>}
        placement="right"
        width={isMobile ? "100%" : 480}
      >
        <MetadataSection drawerData={drawerData} />
      </Drawer>
    </Layout>
  );
};

export default PlaygroundComponent;
